import { useBoundStore } from '@Store/useBoundStore.ts';
import { PARTNER_FLOW_IDS_MAP } from '@Types/consts.ts';
import { GTMEventLabel, GTMEvent } from './types';
import { Entries } from '@Types/util';
import { GTM_EVENT_CATEGORY } from './consts';
import { OnboardingType } from '@Types/index';
import { isEmbedded } from '../../utils';

declare global {
  interface Window {
    dataLayer: Record<string, string | boolean>[];
  }
}

export const dataLayerHandler = async (eventLabel: GTMEventLabel) => {
  const {
    onboardingSlice: { partnerName, isPartnerFlow },
  } = useBoundStore.getState();

  const dataLayerParams = await getDataLayerParams({
    eventLabel,
    partnerName,
    obType: isPartnerFlow ? OnboardingType.CONNECT : OnboardingType.DIRECT,
  });

  for (const [key, value] of Object.entries(dataLayerParams) as Entries<typeof dataLayerParams>) {
    if (!value) continue;
    handlePropExists(key);
    window.dataLayer.push({ [key]: value });
  }

  // Trigger GTM event
  pushGTMEvent(GTMEvent.PUSH_PARAMS);
};

export const pushGTMEvent = (event: GTMEvent) =>
  window.dataLayer.push({
    event,
  });

interface GetDataLayerPropsParams {
  eventLabel: GTMEventLabel;
  partnerName: string;
  obType: OnboardingType;
}

const getDataLayerParams = async ({ eventLabel, partnerName, obType }: GetDataLayerPropsParams) => {
  return {
    /*eslint-disable camelcase */
    event_label: eventLabel,
    embed: isEmbedded().toString(),
    event_category: GTM_EVENT_CATEGORY,
    partner_name: partnerName,
    ob_type: obType,
    /* eslint-enable camelcase */
  } as const;
};

const handlePropExists = (propName: keyof Awaited<ReturnType<typeof getDataLayerParams>>) => {
  window.dataLayer = window.dataLayer.filter((dlProp) => !(propName in dlProp));
};

export const getFlowId = () => {
  const { partnerId } = useBoundStore.getState().customer;
  const partnerFlowId =
    PARTNER_FLOW_IDS_MAP?.[partnerId as keyof typeof PARTNER_FLOW_IDS_MAP] || '';

  if (partnerId && partnerFlowId) {
    return partnerFlowId;
  } else {
    return 'Control';
  }
};
